export default __webpack_public_path__ + "static/media/Vector-2.288ac035.svg";